export const canPOS=(user,key)=>Boolean(user&&(user.role==='super_admin'||user.permissions?.includes(key)));
